<template>
  <div
    v-if="loading"
    class="vp-height-250 d-flex flex-column justify-content-center vp-mb-6"
  >
    <div class="d-flex loading-container">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="loader-content">
        <p>Connecting to kiosk</p>
        <span class="count">You will be able to access kiosk once ready!</span>
      </div>
    </div>
  </div>
  <div v-else style="height:900px">
    <div
      style="display:none"
      class="vp-width-420 margin-auto vp-mb-10 hidden-overflow"
    >
      <h3 class="text-center">Room Credentials</h3>
      <!-- start::Session ID -->
      <div class="d-flex justify-content-between align-items-center vp-mb-5">
        <vp-input
          width="350"
          :readOnly="true"
          label="Session ID"
          v-model="sessionId"
        />

        <button
          id="copy-text-btn"
          class="btn btn-primary"
          @click="copyText('Session ID', sessionId)"
        >
          <i
            class="copy-btn fa fa-regular fa-copy fa-lg vp-font-size-25 vp-mt-5"
          ></i>
        </button>

        <b-tooltip target="copy-text-btn" variant="primary" placement="top">
          Copy Session ID
        </b-tooltip>
      </div>
      <!-- end::Session ID -->

      <!-- start::Session Password -->
      <div class="d-flex justify-content-between align-items-center ">
        <vp-input
          width="350"
          :readOnly="true"
          type="password"
          :passwordIcon="true"
          label="Password"
          v-model="sessionPassword"
        />

        <button
          id="copy-text-btn"
          class="btn btn-primary"
          @click="copyText('Password', sessionPassword)"
        >
          <i
            class="copy-btn fa fa-regular fa-copy fa-lg vp-font-size-25 vp-mt-5"
          ></i>
        </button>

        <b-tooltip target="copy-text-btn" variant="primary" placement="top">
          Copy Password
        </b-tooltip>
      </div>
      <!-- end::Session Password -->
    </div>
    <iframe
      style="overflow:hidden;width:100%;height:120%"
      :src="
        `https://remote.visipoint.dev/web-admin/?roomId=${sessionId}&password=${sessionPassword}`
      "
      id="remoteShareIframe"
      allowfullscreen
      @load="onLoad"
    ></iframe>
  </div>
</template>

<script>
import daemonService from "@/services/daemon";

export default {
  data() {
    return {
      sessionId: "",
      sessionPassword: "",
      loading: true,
    };
  },
  props: {
    kioskInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    copyText(field, value) {
      navigator.clipboard.writeText(value);
      this.$toast.success(`${field} Copied`);
    },
    clearIntervals() {
      for (let i = 1; i < 99999; i++) {
        window.clearInterval(i);
      }
    },
    async onLoad() {},
  },
  async beforeMount() {
    //Notifiy kiosk
    const res = await daemonService.remoteControlNotifyToStart(this.kioskInfo);

    if (res) {
      let intervalId = setInterval(async () => {
        //Get room info (session id , password)
        const { data } = await daemonService.getRoomInfo(
          this.kioskInfo.mac_address
        );

        if (data) {
          window.clearInterval(intervalId);
          this.clearIntervals();

          this.sessionId = data.session_id;
          this.sessionPassword = data.session_password;
          this.loading = false;
        }
      }, 2500);
    }
  },
  async destroyed() {
    this.clearIntervals();
    await daemonService.remoteControlNotifyToEnd(this.kioskInfo);
  },
};

window.onbeforeunload = async function() {
  for (let i = 1; i < 99999; i++) {
    window.clearInterval(i);
  }
};
</script>
<style lang="scss" scoped>
// div[id*="___BV_modal_body_"] {
// height: 1200px;
// overflow: hidden;
// }
.loading-container {
  margin: auto;
  width: fit-content;
  background-color: white;
  align-items: center;
  border-radius: 50px;

  h6 {
    font-weight: 700;
    font-size: 16px;
    line-height: 152%;
    color: #000000;
    margin-bottom: 20px;
  }
  p {
    margin-top: 5px;
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    margin-bottom: 6px;
    line-height: 152%;
  }
  span.count {
    font-weight: 600;
    color: #787878;
    font-size: 14px;
    line-height: 152%;
  }
  .submit-btn {
    margin-inline-end: 0px;
  }
  .btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #ffffff;
  }
  p.reauthenticate {
    font-weight: 600;
    font-size: 14px;
    line-height: 152%;
    color: #787878;
    margin-bottom: 20px;
  }
}
.spinner-border {
  color: #103f5e;
  border-width: 0.35em;
  width: 38px;
  height: 38px;
  margin-inline-end: 22px;
  margin-inline-start: 31px;
  border-right-color: #d9d9d9;
}
.white-bg-sec {
  background-color: white;
  padding-inline-start: 30px;
  padding-top: 32px;
}
.margin-auto {
  margin: auto;
}
.hidden-overflow {
  overflow: hidden !important;
}
</style>
